import type { ExternalTableSchema } from '@packages/table-builder';
import {
  ACCESS_PROFILE_FEATURE_SET_ENTITY,
  ACCESS_PROFILE_ROLE_ENTITY,
} from '@apps/customer/domains/access-profiles/refreshAccessProfileTable';

const accessProfilesListParams = {
  Filter: 'table.searchText',
  MaxResultCount: 'table.pageSize',
  SkipCount: 'table.pageOffset',
  Sorting: 'table.sorting',
  SelectedPermissions: 'filters.selectedPermissions',
} as const;

export const accessProfileRoleTable: ExternalTableSchema = {
  metadata: {
    title: 'System Roles',
    entity: ACCESS_PROFILE_ROLE_ENTITY,
    description: 'Current list of Wealthlane system access roles.',
  },
  dataSource: {
    endpoint: '/api/customer/api/access-profiles',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: { items: 'items', totalCount: 'totalCount' },
    requestParams: {
      ...accessProfilesListParams,
      Type: 'static.2',
    },
  },
  columns: [
    {
      field: 'name',
      header: 'Role Names',
      type: 'modal',
      width: 180,
      sortable: true,
      fields: { id: 'id' },
      modal: { popoverInfo: { kind: 'Role' } },
    },
    { field: 'description', header: 'Description', type: 'text', width: 180, sortable: false },
    {
      field: 'linkedCount',
      header: 'No. of Users',
      type: 'modal',
      width: 180,
      sortable: true,
      fields: { id: 'id' },
      modal: { popoverInfo: { kind: 'User' }, enableTag: true },
    },
    {
      field: 'isEnabled',
      header: 'Role Status',
      type: 'badge',
      width: 180,
      align: 'center',
      visibility: 'picker',
      sortable: false,
      conditionalValues: { true: 'ACTIVE', false: 'INACTIVE' },
      badge: { statusMap: { ACTIVE: 'success', INACTIVE: 'error' } },
    },
    {
      field: 'creationTime',
      header: 'Role Created Date',
      type: 'date',
      width: 180,
      visibility: 'picker',
      sortable: false,
    },
  ],
  actions: {
    toolbar: {
      buttons: [
        {
          id: 'ADD_ACCESS_PROFILE_ROLE',
          label: 'Add Role',
          icon: 'add_circle_outline',
          variant: 'primary',
        },
        {
          id: 'BULK_EDIT_ACCESS_PROFILE_ROLE',
          label: 'Bulk Edit',
          icon: 'discover_tune',
          variant: 'primary-outline',
          requiresSelection: true,
        },
      ],
    },
    row: [
      { id: 'VIEW_ACCESS_PROFILE_ROLE', label: 'View' },
      { id: 'EDIT_ACCESS_PROFILE_ROLE', label: 'Edit' },
      { id: 'COPY_ACCESS_PROFILE_ROLE', label: 'Copy' },
      { id: 'DELETE_ACCESS_PROFILE_ROLE', label: 'Delete', variant: 'danger' },
    ],
  },
  features: {
    search: { enabled: true, placeholder: 'Search' },
    customFilterToolbar: { openActionId: 'FILTER_ACCESS_PROFILE_ROLE' },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
    selection: { keyField: 'id' },
    columnPreferences: {
      persistenceKey: 'System Roles',
      resizable: true,
      reorderable: true,
    },
  },
};

export const accessProfileFeatureSetTable: ExternalTableSchema = {
  metadata: {
    title: 'Feature Set',
    entity: ACCESS_PROFILE_FEATURE_SET_ENTITY,
    description: 'Current list of Wealthlane system Feature Set.',
  },
  dataSource: {
    endpoint: '/api/customer/api/access-profiles',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: { items: 'items', totalCount: 'totalCount' },
    requestParams: {
      ...accessProfilesListParams,
      Type: 'static.1',
    },
  },
  columns: [
    {
      field: 'name',
      header: 'Name',
      type: 'text',
      width: 200,
      sortable: true,
    },
    {
      field: 'description',
      header: 'Description',
      type: 'text',
      width: 200,
      sortable: false,
    },
  ],
  actions: {
    toolbar: {
      buttons: [
        {
          id: 'ADD_ACCESS_PROFILE_FEATURE_SET',
          label: 'Add Feature Set',
          icon: 'add_circle_outline',
          variant: 'primary',
        },
        {
          id: 'BULK_EDIT_ACCESS_PROFILE_FEATURE_SET',
          label: 'Bulk Edit',
          icon: 'discover_tune',
          variant: 'primary-outline',
          requiresSelection: true,
        },
      ],
    },
    row: [
      { id: 'VIEW_ACCESS_PROFILE_FEATURE_SET', label: 'View' },
      { id: 'EDIT_ACCESS_PROFILE_FEATURE_SET', label: 'Edit' },
      { id: 'DELETE_ACCESS_PROFILE_FEATURE_SET', label: 'Delete', variant: 'danger' },
    ],
  },
  features: {
    search: { enabled: true },
    customFilterToolbar: { openActionId: 'FILTER_ACCESS_PROFILE_FEATURE_SET' },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    selection: { keyField: 'id' },
    columnPreferences: {
      persistenceKey: 'Feature Set',
      resizable: true,
      reorderable: true,
    },
  },
};
